import {inject} from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import {  navigationUrlForNewApplication } from '../service/navigation-urls';
import { WHITELABEL_SETTINGS_ACCESS_LEVEL} from '@portal-workspace/grow-shared-library';
import {getUser} from '@portal-workspace/grow-ui-library';

export const whitelabelSettingsDetailsAccessGuard  = (): CanActivateFn => {
  return (
    route: ActivatedRouteSnapshot, state: RouterStateSnapshot
  ) => {
    const router = inject(Router);
    const user = getUser()
    const originatorBusinessId = route.params.originatorBusinessId
    if (user?.priviledges.some(priviledge => WHITELABEL_SETTINGS_ACCESS_LEVEL.includes(priviledge))) {
        return true;
    }
    return router.navigate(navigationUrlForNewApplication())
  }
}